import {
  HttpEvent,
  HttpInterceptorFn,
  HttpResponse,
} from '@angular/common/http';
import { AuthenticationService } from '../services/authentication';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import * as uuid from 'uuid';
import { CORE_SHOP_HEADER, CORE_SHOP_HEADER_VALUE } from '../types/constants';
import { environment } from '../../../environments/environment';

export const tokenInterceptor: HttpInterceptorFn = (request, next) => {
  const auth = inject(AuthenticationService);
  const headers: { [name: string]: string } = {
    'X-bl-trans-id': uuid.v4(),
    'X-BL-ORIGIN': environment.X_BL_ORIGIN,
    [CORE_SHOP_HEADER]: CORE_SHOP_HEADER_VALUE,
  };
  if (auth.isLoggedIn()) {
    headers['Authorization'] = `Bearer ${auth.getToken()}`;
  }

  request = request.clone({
    setHeaders: headers,
  });

  return next(request).pipe(
    tap((event: HttpEvent<any>) => {
      if (
        event instanceof HttpResponse &&
        event.headers.get('X-Auth-Token') &&
        auth.isLoggedIn()
      ) {
        auth.setToken(event.headers.get('X-Auth-Token'));
      }
    })
  );
};
